export default __webpack_public_path__ + "static/media/photo16.2e5da1bb.jpeg";